import CustomerFilters from "./CustomerFilters";
import ProviderFilters from "./ProviderFilters";
import LanguageFilters from "./LanguageFilters";
import GenderFilters from "./GenderFilters";
import IsDisabledFilters from "./IsDisabledFilters";
import TransactionProxyStatusFilters from "./TransactionProxyStatusFilters";
import TransactionProxyStateFilters from "./TransactionProxyStateFilters";

const TableApiFilters: {
  key: string | string[];
  component: React.ComponentType<any>;
}[] = [
  {
    key: ["customer", "customer.name"],
    component: CustomerFilters,
  },
  {
    key: ["provider", "provider.name"],
    component: ProviderFilters,
  },
  {
    key: ["language"],
    component: LanguageFilters,
  },
  {
    key: ["gender"],
    component: GenderFilters,
  },
  {
    key: ["isDisabled"],
    component: IsDisabledFilters,
  },
  {
    key: ["paymentHistory.status"],
    component: TransactionProxyStatusFilters,
  },
  {
    key: ["paymentHistory.state"],
    component: TransactionProxyStateFilters,
  },
];

export default TableApiFilters;
